import { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { ModalBase } from '../../../components/ModalBase';
import { useAuth } from '../../../context/AuthContext';
import { UpdateUsuarioDto, UsuarioResponseDto } from '../../../interfaces/user';
import UsersService from '../../../services/UsersService';

const PasswordForm = (props: { setShowForm: React.Dispatch<React.SetStateAction<boolean>> }) => {
    const { user } = useAuth();
    const [form, setForm] = useState({
        password: '',
        confirmPassword: '',
    });
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [errors, setErrors] = useState<{ [key: string]: string }>({});
    const [success, setSuccess] = useState<UsuarioResponseDto | null>(null);
    const [loading, setLoading] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const validateField = (field: string, value: string) => {
        let error = '';
        switch (field) {
            case 'password': {
                if (!value || value.length < 8) {
                    error = 'La contraseña debe tener al menos 8 caracteres';
                } else if (!/(?=.*[A-Z])(?=.*[a-z])(?=.*\d)/.test(value)) {
                    error = 'Debe contener mayúsculas, minúsculas y números';
                } else if (!/(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~¡¿])/.test(value)) {
                    error = 'Debe contener al menos un caracter especial';
                }
                break;
            }
            case 'confirmPassword': {
                if (value !== form.password) {
                    error = 'Las contraseñas no coinciden';
                }
                break;
            }
            default:
                break;
        }
        setErrors(prev => ({ ...prev, [field]: error }));
        return error === '';
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const fieldValue = value.trim();
        setForm(prev => ({ ...prev, [name]: fieldValue }));
        validateField(name, fieldValue);
        if (name === 'password') {
            validateField('confirmPassword', form.confirmPassword);
        }
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            setLoading(true);
            let valid = true;
            Object.entries(form).forEach(([key, value]) => {
                if (!validateField(key, value)) valid = false;
            });
            if (!valid) return;
            const requestData: UpdateUsuarioDto = {
                id_usuario: user!.id_usuario,
                email: user!.email,
                password: form.password,
            };
            const updatedData = await UsersService.updateUser(requestData);
            setSuccess(updatedData);
            setOpenModal(true);
        } catch (error) {
        } finally {
            setLoading(false);
        }
    };

    const finish = async () => {
        setOpenModal(false);
        props.setShowForm(false);
    };

    return (
        <div className=''>
            <h2>Cambiar Contraseña</h2>
            <form onSubmit={handleSubmit}>
                <div className='form-group'>
                    <label htmlFor='password'>Nueva Contraseña</label>
                    <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                        <input
                            className='input'
                            type={showPassword ? 'text' : 'password'}
                            id='password'
                            name='password'
                            value={form.password}
                            onChange={handleChange}
                            placeholder='••••••••'
                            autoComplete='new-password'
                            style={{ flex: 1 }}
                        />
                        <button
                            type='button'
                            tabIndex={-1}
                            aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                            onClick={() => setShowPassword(v => !v)}
                            style={{
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                padding: 0,
                                color: '#B57EDC',
                                fontSize: 20,
                                marginLeft: -36,
                                zIndex: 2,
                            }}
                        >
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </button>
                    </div>
                    {errors.password && <div className='error-message'>{errors.password}</div>}
                </div>
                <div className='form-group'>
                    <label htmlFor='confirmPassword'>Confirmar Contraseña</label>
                    <div style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                        <input
                            className='input'
                            type={showConfirm ? 'text' : 'password'}
                            id='confirmPassword'
                            name='confirmPassword'
                            value={form.confirmPassword}
                            onChange={handleChange}
                            placeholder='••••••••'
                            autoComplete='new-password'
                            style={{ flex: 1 }}
                        />
                        <button
                            type='button'
                            tabIndex={-1}
                            aria-label={showConfirm ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                            onClick={() => setShowConfirm(v => !v)}
                            style={{
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                padding: 0,
                                color: '#B57EDC',
                                fontSize: 20,
                                marginLeft: -36,
                                zIndex: 2,
                            }}
                        >
                            {showConfirm ? <FaEyeSlash /> : <FaEye />}
                        </button>
                    </div>
                    {errors.confirmPassword && <div className='error-message'>{errors.confirmPassword}</div>}
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                    <button
                        type='submit'
                        className={`btn btn-primary${loading ? ' btn-loading' : ''}`}
                        disabled={loading}
                        style={{ display: 'flex', alignItems: 'center', gap: 8 }}
                    >
                        {!loading && 'Guardar Cambios'}
                    </button>
                </div>
            </form>
            <ModalBase
                isOpen={openModal}
                onRequestClose={() => setOpenModal(false)}
                title={success?.statusCode === 200 ? 'Contraseña actualizada' : success?.message || ''}
                type={success?.statusCode === 200 ? 'success' : 'error'}
                footerButtons={[
                    <button key='cambiar-pass' className='btn btn-primary' onClick={finish}>Ok</button>,
                ]}
            >
                <div></div>
            </ModalBase>
        </div>
    );
};

export default PasswordForm;